import { render } from "./BankWireModal.vue?vue&type=template&id=38688691&scoped=true"
import script from "./BankWireModal.vue?vue&type=script&lang=js"
export * from "./BankWireModal.vue?vue&type=script&lang=js"

import "./BankWireModal.vue?vue&type=style&index=0&id=38688691&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38688691"]])

export default __exports__